/** Returns a human-readable relative time string like "3d ago" */
export function timeAgo(isoString: string): string {
  const ts = new Date(isoString).getTime();
  if (Number.isNaN(ts)) return "unknown";

  const seconds = Math.floor((Date.now() - ts) / 1000);

  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks}w ago`;
  const months = Math.floor(days / 30);
  return `${months}mo ago`;
}
